// extracted by mini-css-extract-plugin
module.exports = {"dateWrapper":"_a85fdf5","message":"_a92eafe","wrapper":"_5e0d446"};